





















import { Component, Vue } from "vue-property-decorator";
import { NotificationService } from "@/services/notification_service";

@Component
export default class ToastNotifications extends Vue {
  get notifications() {
    return NotificationService.notifications;
  }

  remove(id: number) {
    NotificationService.remove(id);
  }

  statusClass(status: string): string {
    switch (status) {
      case "danger":
        return "bg-red-600 text-white";
      case "success":
        return "bg-green-600 text-white";
      case "warning":
        return "bg-yellow-500 text-white";
      default:
        return "bg-red-600 text-white";
    }
  }
}
